module.exports = __webpack_public_path__ + "img/hazardEquip85.43a478be.jpg";